// extracted by mini-css-extract-plugin
module.exports = {"rightSidebarOpener":"RightSidebarOpener_rightSidebarOpener__3bheF","closeBtn":"RightSidebarOpener_closeBtn__15ut9"};